// extracted by mini-css-extract-plugin
module.exports = {"select":"PriorAuthFilterSelect_select__1TZEY"};